export declare class PopupType {
  popup: HTMLElement | null;
  triger: NodeListOf<HTMLElement> | null;
  close: NodeListOf<HTMLElement> | null;
  overlay: HTMLElement | null;
  isOpen: boolean;
  constructor(popup: string, triger: string, close: string);
  recunstruct: (
    popup: string | null,
    triger: string | null,
    close: string | null,
  ) => void;
  init: () => void;
  reset: () => void;
  overlayClose: () => void;
  openPopup: () => void;
  onTriggerClick: () => void;
  setOverlay: () => void;
  setClose: () => void;
  closeAll: () => void;
}

export class Popup implements PopupType {
  popup: HTMLElement | null = null;
  triger: NodeListOf<HTMLElement> | null = null;
  close: NodeListOf<HTMLElement> | null = null;
  overlay: HTMLElement | null = document.getElementById('overlay');
  isOpen: boolean = false;

  constructor(popup: string, triger: string, close: string) {
    this.popup = document.querySelector(popup) as HTMLElement | null;
    this.triger = document.querySelectorAll(triger) as NodeListOf<HTMLElement>;
    this.close = document.querySelectorAll(close) as NodeListOf<HTMLElement>;
  }

  recunstruct(
    popup: string | null,
    triger: string | null,
    close: string | null,
  ) {
    this.reset();
    if (popup) {
      this.popup = document.querySelector(popup) as HTMLElement | null;
      this.popup?.classList.add('init');
    }
    if (triger) {
      this.triger = document.querySelectorAll(
        triger,
      ) as NodeListOf<HTMLElement> | null;
    }
    if (close) {
      this.close = document.querySelectorAll(close) as NodeListOf<HTMLElement>;
    }
  }

  init() {
    this.popup?.classList.add('init');
    this.openPopup();
    this.overlayClose();
    this.setClose();
    this.resetSlider();
  }

  reset() {
    if (this.popup && this.triger) {
      this.popup.dataset.open = 'false';
      this.triger.forEach((item) => {
        item.dataset.open = 'false';
        item.classList.remove('activeClass', 'jsPopupOpen');
      });

      this.popup.classList.remove('activeClass', 'jsPopupOpen');
    }
  }

  overlayClose() {
    this.overlay?.addEventListener('click', () => {
      this.isOpen = false;
      this.setOverlay();
    });
  }

  openPopup() {
    if (this.popup && this.triger) {
      this.triger.forEach((item) => {
        item.addEventListener('click', this.onTriggerClick.bind(this));
      });
    }
  }

  onTriggerClick() {
    if (this.popup) {
      if (!this.isOpen) {
        this.isOpen = true;
        this.setOverlay();
        window.dispatchEvent(window.popupOpenEvent);
      } else {
        this.isOpen = false;
        this.setOverlay();
      }
    }
  }

  setOverlay() {
    if (this.popup && this.triger) {
      if (this.isOpen) {
        this.closeAll();
        this.popup.classList.add('activeClass', 'jsPopupOpen');
        this.popup.dataset.open = 'true';
        this.triger.forEach((item) => {
          item.dataset.open = 'true';
          item.classList.add('activeClass', 'jsPopupOpen');
        });
        this.overlay?.classList.add('activeClass');
        document.documentElement.style.overflow = 'hidden';
        document.body.classList.add('activeClass');
      } else {
        this.popup.classList.remove('activeClass', 'jsPopupOpen');
        this.popup.dataset.open = 'false';
        this.triger.forEach((item) => {
          item.dataset.open = 'false';
          item.classList.remove('activeClass', 'jsPopupOpen');
        });

        this.overlay?.classList.remove('activeClass');
        document.documentElement.style.overflow = 'auto';
        document.body.classList.remove('activeClass');
      }
    }
  }
  setClose() {
    this.close?.forEach((item) => {
      item.addEventListener('click', () => {
        this.isOpen = false;
        this.setOverlay();
        
      });
    });
  }
  resetSlider() {
    window.addEventListener('closePopups', () => {
      this.closeAll();
    });
  }
  closeAll() {
    const popups = document.querySelectorAll(
      '.jsPopupOpen',
    ) as NodeListOf<HTMLElement>;
    this.overlay?.classList.remove('activeClass');
    document.documentElement.style.overflow = 'auto';
    document.body.classList.remove('activeClass');
    window.dispatchEvent(window.popupsClosedEvent);
    popups.forEach((item) => {
      item.classList.remove('activeClass', 'jsPopupOpen');
      item.dataset.open = 'false';
    });
  }
}
